<div class="c-status-label">
  <i [ngClass]="iconClass" *ngIf="showIcon" class="icon-marker-arrow-right"></i>
  <span translate>VEHICLE_STATUS.{{status}}</span>
  <div class="c-ignition" *ngIf="ignition"></div>
</div>
